// currency code, currency symbol key value pairs
// TODO: Delete comments in the CURRENCY_MAP once the currency symbols are verified and tested to be accurate
export const CURRENCY_MAP = {
  ARS: 'AR$', // was $ which is correct locally but AR$ is more specific
  AUD: 'A$', // was $, correct A$
  BSD: 'BSD$',
  BBD: 'Bds$', // $ is used, Bds$ more specific
  BZD: 'BZ$', // Correct as BZ$, not just $ as before
  BMD: 'BD$', // $ is common, BD$ is clearer
  BND: 'B$', // $ is used locally
  CAD: 'CA$', // was $, correct 'CA$'
  CVE: '$',
  KYD: '$',
  CLP: '$',
  COP: '$',
  DOP: '$',
  XCD: '$',
  FJD: '$',
  GYD: '$',
  HKD: '$',
  JMD: '$',
  LRD: '$',
  MXN: '$',
  NAD: '$',
  NZD: '$',
  UYU: '$',
  SGD: '$',
  SBD: '$',
  SRD: '$',
  WST: '$',
  TTD: 'TT$',
  USD: '$',
  BES: '$',
  ZWL: '$',
  MXV: 'UDI', // was '-',  correct symbol for MXV can be written “UDI”
  PAB: 'B/.',
  ETB: 'Br',
  VEF: 'Bs.',
  BOB: 'Bs.',
  NIO: 'C$',
  XAF: 'F.CFA', // correct F.CFA, was 'CFA Franc BEAC'
  CHF: 'CHF',
  GMD: 'D',
  STN: 'Db',
  KMF: 'FC',
  XOF: 'Franc',
  XPF: '₣', // correct '₣', was Franc
  HUF: 'Ft',
  HTG: 'G',
  PGK: 'K',
  HRK: 'Kn',
  ISK: 'Kr',
  CZK: 'Kč',
  HNL: 'L',
  SZL: 'L',
  LSL: 'L',
  MDL: 'L',
  RON: 'L',
  SLL: 'Le',
  ALL: 'Lek',
  MWK: 'MK',
  MGA: 'MK',
  MZN: 'MTn',
  MMK: 'K', // correct K // was 'Myanmar is K'
  TWD: 'NT$',
  ERN: 'Nfk',
  BTN: 'Nu',
  MOP: 'P',
  BWP: 'P',
  GTQ: 'Q',
  ZAR: 'R',
  BRL: 'R$',
  MYR: 'RM',
  IDR: 'Rp',
  SCR: 'Rs',
  LKR: 'Rs',
  PEN: 'S/.',
  SSP: 'SS£',
  KES: 'Sh',
  SOS: 'Sh',
  TZS: 'Sh',
  UGX: 'Sh',
  TOP: 'T$',
  TRY: 'TL',
  MRU: 'UM',
  VUV: 'Vt',
  ZMW: 'ZK',
  RSD: 'din',
  AOA: 'is',
  NOK: 'kr',
  SEK: 'kr',
  DKK: 'kr.',
  TMT: 'm',
  BYN: 'p.',
  PLN: 'zł',
  EGP: '£',
  FKP: '£',
  GIP: '£',
  GBP: '£',
  SHP: '£',
  SDG: '£',
  SYP: '£',
  JPY: '¥',
  CNY: '¥',
  AWG: 'ƒ',
  ANG: 'ƒ',
  TJS: 'ЅМ',
  BAM: 'КМ',
  MKD: 'ден',
  BGN: 'лв',
  KGS: 'лв',
  UZS: 'лв',
  AMD: 'Դ',
  AFN: '؋',
  BHD: 'ب.د',
  JOD: 'د.ا',
  TND: 'د.ت',
  DZD: 'د.ج',
  KWD: 'د.ك',
  MAD: 'د.م.',
  AED: 'د.م.',
  SAR: 'ر.س',
  QAR: 'ر.ق',
  IQD: 'ع.د',
  LYD: 'ل.د',
  LBP: 'ل.ل',
  MVR: 'ރ',
  BDT: '৳',
  THB: '฿',
  GEL: 'ლ',
  KHR: '៛',
  CRC: '₡',
  BIF: 'FBu', // correct FBu, was ₣
  CDF: 'FC', // correct FC, was ₣
  DJF: 'Fdj', // correct Fdj,was ₣
  GNF: 'FG', // correct FG, was  ₣
  RWF: 'FRw', // correct FRw,was ₣
  NGN: '₦',
  MUR: '₨',
  NPR: '₨',
  PKR: '₨',
  KPW: '₩',
  KRW: '₩',
  ILS: '₪',
  VND: '₫',
  EUR: '€',
  LAK: '₭',
  MNT: '₮',
  CUP: '₱',
  PHP: '₱',
  PYG: '₲',
  UAH: '₴',
  GHS: '₵',
  INR: '₹',
  AZN: '₼',
  RUB: '₽',
  KZT: '〒',
  IRR: '﷼',
  OMR: '﷼',
  YER: '﷼',
};
